<template>
  <el-row>
    <el-col :span="12" :offset="6">
      <div style="font-size:20px">User</div>
      <el-form
        :model="user"
        ref="user"
        :rules="rules"
        label-width="120px"
        style="margin:20px"
        label-position="left"
        :disabled="!$store.getters.isAdmin"
      >
        <el-form-item label="User:" prop="userLogin">
          <el-input v-model="user.userLogin"></el-input>
        </el-form-item>
        <el-form-item label="First Name:" prop="firstName">
          <el-input v-model="user.firstName"></el-input>
        </el-form-item>
        <el-form-item label="Last Name:" prop="lastName">
          <el-input v-model="user.lastName"></el-input>
        </el-form-item>
        <el-form-item label="Is Admin:" prop="isAdmin">
          <el-switch v-model="user.isAdmin"/>
        </el-form-item>
        <el-form-item label="Enabled:" prop="isActive">
          <el-switch v-model="user.isActive"/>
        </el-form-item>
        <el-form-item label="New Pwd:" prop="userPassword"  v-if='$store.getters.isAdmin'>
          <el-input v-model="user.userPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="Check Pwd:" prop="checkUserPassword"  v-if='$store.getters.isAdmin'>
          <el-input v-model="checkUserPassword" show-password></el-input>
        </el-form-item>

        <el-form-item v-if='$store.getters.isAdmin'>
          <el-button type="primary" @click="save()">Save</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { once } from "events";
import axios from "axios";

const uuidv4 = require("uuid/v4");

export default {
  name: "User",
  props: ["id"],
  data() {
    var validatePass1 = (rule, value, callback) => {
      if(this.user.externalId == null && !this.user.userPassword){
        callback(new Error("Please input User Password"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (this.checkUserPassword !== this.user.userPassword) {
        callback(new Error("The two passwords don't match!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        externalId: null,
        firstName: null,
        lastName: null,
        userLogin: null,
        isAdmin: false,
        isActive: true,
        userPassword: null
      },
      checkUserPassword: null,
      rules: {
        userLogin: [
          {
            required: true,
            message: "Please input User Login",
            trigger: "blur"
          }
        ],
        firstName: [
          {
            required: true,
            message: "Please input First Name",
            trigger: "blur"
          }
        ],
        lastName: [
          { required: true, message: "Please input Last Name", trigger: "blur" }
        ],
        email: [
          { required: true, message: "Please input Email", trigger: "blur" }
        ],
        userPassword: [{ validator: validatePass1, trigger: "blur" }],
        checkUserPassword: [{ validator: validatePass2, trigger: "blur" }],
       }
    };
  },

  computed: {},

  created() {
    if (this.id !== "add") {
      let url = `${process.env.VUE_APP_API}application-users/${this.id}`;
      axios
        .get(url, {
          headers: {
            authorization: window.sessionStorage.getItem("token")
          }
        })
        .then(result => {
          this.user = result.data;
        })
        .catch(reason => {});
    } else {
      // we have a new user
    }
  },

  methods: {
    save() {
      this.$refs["user"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },

    saveData() {
      if (this.user.externalId != null) {
        //  PATCH to update
        let url = `${process.env.VUE_APP_API}application-users/${this.id}`;
        axios
          .patch(url, this.user, {
            headers: {
              authorization: window.sessionStorage.getItem("token")
            }
          })
          .then(result => {
            this.$message({
              message: "Data saved successfully",
              type: "success"
            });
          })
          .catch(reason => {
            this.$message({
              message: "Save operation failed",
              type: "error"
            });
          });
      } else {
        let url = `${process.env.VUE_APP_API}application-users`;
        axios
          .post(url, this.user, {
            headers: {
              authorization: window.sessionStorage.getItem("token")
            }
          })
          .then(result => {
            this.user.externalId = result.data.externalId;

            this.$message({
              message: "Data saved successfully",
              type: "success"
            });

            this.$router.replace({
              name: "User",
              params: { id: this.user.externalId }
            });
          })
          .catch(reason => {
            this.$message({
              message: "Save operation failed",
              type: "error"
            });
          });
      }
    },

    // onTickets() {
    //   this.$router.push("/tickets");
    // },

    // onUsers() {
    //   this.$router.push("/users");
    // }
  }
};
</script>
